<template>
  <div class="map container">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
    >
      <router-link
        class="branch"
        v-for="(item, index) in branchs"
        :key="index"
        :to="item.path"
      >
        {{ item.branch }}
      </router-link>
    </el-dialog>
    <div id="myeg"></div>
  </div>
</template>

<script>
import '@/assets/js/china.js'
export default {
  name: 'JsMap',
  data () {
    return {
      dialogVisible: false,
      title: '',
      branchs: [],
      option: {
        tooltip: {
          formatter: function (params, ticket, callback) {
            if (params['data']) {
              if (params.data['children']) {
                let ch = params.data['children']
                let html = ``
                ch.forEach(i => {
                  html += `<div>${i['branch']}</div>`
                })
                return html
              }
              return params.data.branch || params.data.name
            }
          }
        },
        visualMap: {
          min: 0,
          max: 100,
          inRange: {
            color: ['#01a1eb']
          },
          show: false// 图注
        },
        geo: {
          map: 'china',
          roam: false, // 不开启缩放和平移
          zoom: 1.23, // 视角缩放比例
          label: {
            normal: {
              show: true,
              fontSize: '10',
              color: 'rgba(0,0,0,0.7)'
            }
          },
          itemStyle: {
            normal: {
              borderColor: 'rgba(0, 0, 0, 0.2)'
            },
            emphasis: {
              areaColor: '#F3B329', // 鼠标选择区域颜色
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        },
        series: [
          {
            type: 'map',
            geoIndex: 0,
            data: [{
              name: '上海',
              value: 100,
              branch: '',
              path: '/branch/shanghai'
            }, {
              name: '辽宁',
              value: 100,
              branch: '大连',
              path: '/branch/dalian'
            }, {
              name: '山东',
              value: 100,
              children: [{
                branch: '青岛',
                path: '/branch/qingdao'
              }, {
                branch: '烟台',
                path: '/branch/yantai'
              }, {
                branch: '威海',
                path: '/branch/weihai'
              }]
            }, {
              name: '天津',
              value: 100,
              branch: '',
              path: '/branch/tianjin'
            }, {
              name: '江苏',
              branch: '南京',
              value: 100,
              path: '/branch/nanjing'
            }, {
              name: '浙江',
              value: 100,
              branch: '宁波',
              path: '/branch/ningbo'
            }, {
              name: '湖北',
              value: 100,
              branch: '武汉',
              path: '/branch/wuhan'
            }, {
              name: '湖南',
              value: 100,
              branch: '长沙',
              path: '/branch/changsha'
            }, {
              name: '广东',
              value: 100,
              children: [{
                branch: '广州',
                path: '/branch/guangzhou'
              }, {
                branch: '深圳',
                path: '/branch/shenzhen'
              }]
            }, {
              name: '香港',
              value: 100,
              branch: '',
              path: '/branch/xianggang'
            }]
          }
        ]
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      let that = this
      let myChartEg = this.$echarts.init(document.getElementById('myeg'))
      // 绘制图表
      myChartEg.setOption(this.option)
      myChartEg.on('click', function (params) {
        if (params['data']) {
          if (params.data.children) {
            that.title = params.data.name
            that.branchs = params.data.children
            that.dialogVisible = true
          } else {
            that.$router.push(params.data.path)
          }
        }
      })
      window.addEventListener('resize', function () {
        myChartEg.resize()
      })
    },
    randomValue () {
      return Math.round(Math.random() * 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.branch {
  color: #333;
  text-decoration: none;
  margin: 10px;
  &:hover {
    text-decoration: underline;
    color: #01a1eb;
  }
}
#myeg {
  width:800px;
  height:600px;
  margin: 10px auto;
}
</style>
